module.exports = __webpack_public_path__ + "img/accessory_pants_03.cd824a0a.svg";